<template>
  <div>
    <frontHeaderNavigation></frontHeaderNavigation>
    <router-view></router-view>
  </div>
</template>

<script>
import frontHeaderNavigation from '@c/navigation/frontHeaderNavigation.vue'
export default {
  name: 'FrontFrame',
  components: {
    frontHeaderNavigation
  }
}
</script>
